var map = {
	"./ID.webp": 785,
	"./INDO.webp": 786,
	"./MY.webp": 787,
	"./TH.webp": 788,
	"./VN.webp": 789,
	"./malaysia.webp": 790
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 394;
module.exports = webpackAsyncContext;